import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { UncontrolledTooltip } from "reactstrap";
const SingleRowAction = ({
  to,
  onClick,
  record,
  actionName,
  color,
  iconClass,
  target,
  iconSize = "font-size-18",
}) => {
  return (
    <Fragment>
      {onClick && !to ? (
        <button
          type="button"
          color="link"
          className={`btn btn-transparent p-0 border-0 ${
            color ? color : "text-gray-600"
          }`}
          onClick={onClick}
        >
          <i
            className={`${iconClass} ${iconSize}`}
            id={`${actionName.replaceAll(" ", "")}tooltip${record?.id}`}
          />
          <UncontrolledTooltip
            placement="top"
            target={`${actionName.replaceAll(" ", "")}tooltip${record?.id}`}
          >
            {actionName}
          </UncontrolledTooltip>
        </button>
      ) : (
        <Link
          to={to}
          className={color ? color : "text-gray-600"}
          target={target ? target : "_self"}
        >
          <i
            className={`${iconClass} ${iconSize}`}
            id={`${actionName.replaceAll(" ", "")}tooltip${record?.id}`}
          />
          <UncontrolledTooltip
            placement="top"
            target={`${actionName.replaceAll(" ", "")}tooltip${record?.id}`}
          >
            {actionName}
          </UncontrolledTooltip>
        </Link>
      )}
    </Fragment>
  );
};

export default SingleRowAction;
